import React from 'react';

import { emojiToCdnUrl } from 'widget/utils/emoji';

import styles from './EmojiPickerItem.module.scss';

type EmojiPickerItemProps = {
  emoji: string;
  isLoaded: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseDown: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const EmojiPickerItem: React.FC<EmojiPickerItemProps> = ({
  emoji,
  isLoaded,
  onClick,
  onMouseDown
}) => {
  const [imgReady, setImgReady] = React.useState(false);

  const handleImgLoad = React.useCallback(() => {
    setImgReady(true);
  }, []);

  const showNative = !isLoaded || !imgReady;

  return (
    <button
      type="button"
      className={styles['emoji']}
      data-emoji={emoji}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {showNative && <span className={styles['emoji__native']}>{emoji}</span>}
      {isLoaded && (
        <img
          className={styles['emoji__img']}
          src={emojiToCdnUrl(emoji)!}
          alt={emoji}
          draggable={false}
          onLoad={handleImgLoad}
          style={imgReady ? undefined : { position: 'absolute', opacity: 0 }}
        />
      )}
    </button>
  );
};

export default React.memo(EmojiPickerItem);
